// @ts-nocheck
import { debounce } from '@theme/utilities';

/**
 * A custom element that displays a slider.
 */

class SliderComponent extends HTMLElement {
    constructor() {
        super();

        this.slider = this;
        this.flkty = null;
        this.thumbails = document.querySelectorAll('.gallery-thumbnail-button');
        this.parentSlider = this.slider.getAttribute('data-parent-slider') || null;

        this.prevButtons = this.querySelectorAll('.slider-button[name="previous"]');
        this.nextButtons = this.querySelectorAll('.slider-button[name="next"]');
        this.initManually = this.slider.getAttribute('data-init-manually') || false;

        if(!this.initManually){
            this.init();
        }  

        this.prevButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.flkty.previous();
            });
        })
        
        this.nextButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.flkty.next();
            });
        })
    }

    init() {
        const slider = this.slider.querySelector('.slider-inner');
        if(!slider) return;

        const draggable = this.getAttribute('data-draggable')?.toLowerCase() === 'false' ? false : true;
        const wrapAround = this.getAttribute('data-wrap-around')?.toLowerCase() === 'true' ? true : false;
        // Tuned to approximate the main menu drawer's easing feel
        // (`--ease-out: cubic-bezier(0.4, 0, 0.2, 1)`, ~0.4-0.5s) — Flickity
        // has no CSS-curve equivalent, so this is the closest match via its
        // spring physics: attraction lowered from Flickity's snappier
        // defaults for a more visible glide, friction kept high so it
        // settles in one smooth motion with no bounce/overshoot.
        const selectedAttraction = parseFloat(this.getAttribute('data-selected-attraction')) || 0.06;
        const friction = parseFloat(this.getAttribute('data-friction')) || 0.8;

        this.flkty = new Flickity(slider, {
            cellAlign: 'left',
            contain: true,
            wrapAround: wrapAround,
            prevNextButtons: false,
            pageDots: false,
            draggable: draggable,
            setGallerySize: false,
            selectedAttraction: selectedAttraction, //speed
            friction: friction, //bounciness
            dragThreshold: 10,
            on: {
                ready: () => {
                    this.toggleDrag();
                    this.classList.add('slider-ready');
                    this.setSliderClasses();
                    this.setThumbnails();
                }
            },
            });

            window.addEventListener(
            'resize', debounce(() => {            
                this.toggleDrag();
                this.flkty.resize();
            }, 10)
        );

        if(this.thumbails.length > 0){
            this.flkty.on('change', (index) => {
                this.thumbails.forEach(t => t.classList.remove('is-active'));
                this.thumbails[index].classList.add('is-active');
            });
        }  
        
        if(this.parentSlider){
            this.setGallery();
        }
    }

    setGallery(){
        const TABLET_MAX = 959;
        const mainImages = document.querySelectorAll(`#${this.parentSlider} .main-image`).forEach(image => {
            image.addEventListener('click', (event) => {
                // Only 'image' media has a corresponding slide/thumbnail set up in the
                // gallery slider (see blocks/product-media.liquid) - other media types
                // (e.g. 3D models, which have their own click/drag interactions) should
                // not trigger the gallery to open.
                if (image.dataset.mediaType && image.dataset.mediaType !== 'image') return;

                // The AI-tag pill sitting on top of the image is its own
                // click target (opens the AI-disclosure drawer) - don't let
                // that click also open the gallery underneath it.
                if (event.target.closest('.ai-tag')) return;

                if(window.innerWidth > TABLET_MAX) {
                    this.slider.classList.add('open');
                    document.documentElement.setAttribute('scroll-lock', '');

                    requestAnimationFrame(() => {
                        this.flkty.resize();
                        this.toggleDrag();
                        this.flkty.select(parseInt(image.dataset.slideIndex));
                    });
                }
            })
        })

        const closeBtn = this.querySelector('.close-gallery-button');
        
        if(closeBtn) {
            closeBtn.addEventListener('click', () => {
                this.closeGallery();
            })
        }

        document.addEventListener('keydown', (e) => {
            if (!this.slider.classList.contains('open')) return; // only when open

            switch(e.key) {
                case 'Escape':
                this.closeGallery();
                break;
                case 'ArrowLeft':
                this.flkty.previous();
                break;
                case 'ArrowRight':
                this.flkty.next();
                break;
            }
        });
    }

    closeGallery(){
        this.slider.classList.remove('open');
        document.documentElement.removeAttribute('scroll-lock');
    }

    setThumbnails() { 
        if(!this.thumbails) return;

        this.thumbails.forEach((thumb) => {
            thumb.addEventListener('click', () => {
                const index = parseInt(thumb.dataset.slideIndex);
                this.flkty.select(index);
            });
        });
    }

    setSliderClasses() {
        const flickityInner = this.slider.querySelector('.flickity-slider');

        const desktopClasses = this.slider.getAttribute('data-grid-desktop-classes');

        if(desktopClasses){
            flickityInner.classList.add('grid-el-desktop');
            flickityInner.classList.add(desktopClasses);
        }

        const mobileClasses = this.slider.getAttribute('data-grid-mobile-classes');

        if(mobileClasses){
            flickityInner.classList.add('grid-el-mobile');
            flickityInner.classList.add(mobileClasses);
        }
    }

    toggleDrag() {
        const innerSlider = this.slider.querySelector('.flickity-slider');
        let slidesWidth = 0;


        this.querySelectorAll('.slide-item, .product-gallery-slide, .product-media-item').forEach(slide => {
            slidesWidth += slide.offsetWidth; 
        })

        if (slidesWidth <= innerSlider.offsetWidth) {
            this.slider.classList.add('no-drag-slider');
        } else {
            this.slider.classList.remove('no-drag-slider');
        }
    }
}

if (!customElements.get('slider-component')) {
  customElements.define('slider-component', SliderComponent);
}